import { skipToken } from '@reduxjs/toolkit/query';
import { useParams } from 'react-router-dom';

import { useGetAhuUnitQuery, useGetCmsAhuDocQuery } from 'app/services/ahuBoardApi';

/**
 * The air stream ids this AHU's construction class offers, or `undefined`
 * while the answer is not known yet.
 *
 * Read from the board's own CMS document, which is keyed on the AHU's class
 * and is already in RTK Query's cache by the time any selection dialog opens
 * — so this is a cache read, not a fetch.
 *
 * `undefined` means "not scoped yet" and `airStreamOptions` then offers
 * everything, which is what keeps a dialog usable while the unit or the
 * document is still in flight.
 */
export const useAirStreamOfferedIds = (): number[] | undefined => {
  const { ahuId } = useParams();
  const id = Number(ahuId);
  const { data: unit } = useGetAhuUnitQuery(Number.isFinite(id) ? id : skipToken);
  const mfgId = (unit as { mfg_id?: number } | undefined)?.mfg_id ?? 1;
  const classId = (unit as { construction_class_id?: number } | undefined)
    ?.construction_class_id;
  const { data: cms } = useGetCmsAhuDocQuery(
    classId ? { mfgId, constructionClassId: classId } : skipToken
  );
  const air = (cms as { air?: { air_stream_offered_ids?: number[] } } | undefined)?.air;
  return air?.air_stream_offered_ids;
};
